import React, { useState } from "react";
import {
	MDBNavbar,
	MDBNavbarBrand,
	MDBNavbarNav,
	MDBNavItem,
	MDBNavbarToggler,
	MDBCollapse,
	MDBContainer,
} from "mdbreact";

import { Link } from "gatsby";
import { GGgetMode } from "../../services/gglocalstorage";
import Logo from "../../assets/images/home/logo_branco.svg";

import "./MainNavbar.css";

export default function MainNavbar() {
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	return (
		<MDBNavbar
			expand="md"
			color="indigo"
			dark
			className="text-center aling-itens-center"
		>
			<MDBContainer>
				<MDBNavbarBrand>
					<Link to={GGgetMode() ? "/gg/" : "/"}>
						<img
							src={Logo}
							alt="Universidade Feevale"
							className="img-fluid"
							style={{ maxWidth: "160px", height: "70px" }}
						/>
					</Link>
				</MDBNavbarBrand>

				<MDBNavbarToggler
					onClick={() => {
						setIsMenuOpen(!isMenuOpen);
					}}
					style={{ backgroundColor: "#085630" }}
				/>

				<MDBCollapse id="navbarCollapse3" isOpen={isMenuOpen} navbar>
					<MDBNavbarNav left className="align-items-center">
						<MDBNavItem active className="my-md-auto my-1">
							<Link
								className="mx-md-3 mx-lg-4"
								style={{ color: "#fff" }}
								to="/cursos/"
								activeClassName={
									"active " +
									(GGgetMode()
										? "text-secondary font-weight-bold"
										: "text-light font-weight-bold")
								}
							>
								Cursos
							</Link>
						</MDBNavItem>

						<MDBNavItem active className="my-md-auto my-1">
							<Link
								className="mx-md-3 mx-lg-4"
								style={{ color: "#fff" }}
								to="/cursos/medicina"
								activeClassName={
									"active " +
									(GGgetMode()
										? "text-secondary font-weight-bold"
										: "text-light font-weight-bold")
								}
							>
								Medicina
							</Link>
						</MDBNavItem>

						<MDBNavItem active className="my-md-auto my-1">
							<Link
								className="mx-md-3 mx-lg-4"
								style={{ color: "#fff" }}
								to={GGgetMode() ? "/gg/descontos" : "/descontos"}
								activeClassName={
									"active " +
									(GGgetMode()
										? "text-secondary font-weight-bold"
										: "text-light font-weight-bold")
								}
							>
								{GGgetMode() ? "Bolsas e descontos" : "Descontos"}
							</Link>
						</MDBNavItem>

						<MDBNavItem active className="my-md-auto my-1">
							<Link
								className="mx-md-3 mx-lg-4 align-middle"
								to={GGgetMode() ? "/gg/contato" : "/contato"}
								style={{ color: "#fff" }}
								activeClassName={
									"active " +
									(GGgetMode()
										? "text-secondary font-weight-bold"
										: "text-light font-weight-bold")
								}
							>
								Contato
							</Link>
						</MDBNavItem>

						<MDBNavItem active className="my-md-auto my-1">
							<Link
								className="mx-md-3 mx-lg-4 align-middle"
								to="https://forms.gle/kKCFGk1Zv2ZjRW4o9"
								style={{ color: "#fff" }}
								activeClassName={
									"active" +
									(GGgetMode()
										? "text-white font-weight-bold"
										: "text-white font-weight-bold")
								}
								target="blank"
							>
								Visite o Câmpus
							</Link>
						</MDBNavItem>
					</MDBNavbarNav>

					<MDBNavbarNav right className="py-2 p-md-0">
						<MDBNavItem className="my-3 my-md-0 col-12 col-md d-flex justify-content-md-end">
							<Link
								to={GGgetMode() ? "/gg/inscrevase" : "/inscrevase"}
								className="mainNavbar-ctaLink"
							>
								<span className="mainNavbar-tag" aria-label="Inscreva-se">
									<span className="mainNavbar-tagBody">
										<span className="mainNavbar-tagTitle">
											Inscreva-se
										</span>
									</span>

									<span className="mainNavbar-tagSide">
										<span className="mainNavbar-tagSideText">
											Feevale
										</span>
									</span>
								</span>
							</Link>
						</MDBNavItem>
					</MDBNavbarNav>
				</MDBCollapse>
			</MDBContainer>
		</MDBNavbar>
	);
}
